import _ from 'lodash';
import React from 'react';
import ReactSelect from 'react-select';
import autobind from 'autobind-decorator';

import Field from './field';

// import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

const isReallyEmpty = (value) => _.isUndefined(value) || _.isNull(value);

class Select extends Field {
	state = {
		valid: true,
		selectedOption: null,
	}

	componentDidMount () {
		const { fieldKey, dataId, store, formStore } = this.props;
		const { valueKey } = formStore.get(fieldKey);

		const value = this.getValue({ store, fieldKey, dataId, valueKey });

		if (_.isEmpty(value)) {

			return;
		}

		this.setState({
			selectedOption: value
		});
	}

	@autobind
	onChange (selectedOption) {
		const { fieldKey, formStore } = this.props;
		const { multi = false } = formStore.get(fieldKey);

		this.setState({ selectedOption });

		this.handleChange({
			target: {
				value: multi ? selectedOption.map(({ value }) => value) : selectedOption.value
			}
		});
	}

	renderInput () {
		const { fieldKey, dataId, store, optionsStore, formStore } = this.props;
		const { injectOptions, options, valueKey, multi = false } = formStore.get(fieldKey);

		const injectedOptions = formStore.getInjectOptions({
			dataStore: optionsStore || store,
			injectOptions: injectOptions
		});

		const value = this.getValue({ store, fieldKey, dataId, valueKey });

		return (
			<div data-ta={ `${fieldKey}` }>
				<ReactSelect
					type="text"
					multi={ multi }
					closeOnSelect={ multi !== true }
					clearable={ false }
					id={ fieldKey }
					name={ fieldKey }
					defaultValue={ value }
					value={ this.state.selectedOption }
					onChange={ this.onChange }
					options={ options.concat(injectedOptions) }
					placeholder={ this.props.placeholder }
					styles={{ justifyContent: 'center', display: 'flex', padding: '2vh'}}
				/>
			</div>
		);
	}
}

export default Select;
